var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtractAndStay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ef5c69",
    d: "M14.625 2.25H3.375A1.125 1.125 0 0 0 2.25 3.375v11.25a1.125 1.125 0 0 0 1.125 1.125h11.25a1.125 1.125 0 0 0 1.125-1.125V3.375a1.125 1.125 0 0 0-1.125-1.125m0 12.375H3.375V3.375h11.25z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ef5c69",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 7h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.33 7v4.666a.667.667 0 0 1-.666.667H7.331a.667.667 0 0 1-.667-.667V6.999m1 0v-.666a.667.667 0 0 1 .667-.667h1.333a.667.667 0 0 1 .667.667v.666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "#fff",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtractAndStay);
export default __webpack_public_path__ + "static/media/ExtractAndStay.0483acf6ec74fae45592488047418905.svg";
export { ForwardRef as ReactComponent };